import { Container, Card } from "reactstrap";
import styles from './styles.module.scss';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Navigation, Autoplay } from "swiper";
import useTestimonials from "@/hooks/useTestimonials";
import { useRouter } from "next/router";
import Quote from "/public/site-assets/svg/quote.svg";
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/autoplay';

export const LatestTestimonials = ({
    className,
    title,
    titleColour,
    content,
    tag,
}) => {
    
    const locale = useRouter().asPath.startsWith("/us/") ? "/us/" : "/";
    
    const items = useTestimonials({ locale, filters: tag });

    if (!items || !items.length > 0) {
        return null;
    }

    const settings = {
        modules: [Navigation, Pagination, Autoplay],
        loop: true,
        spaceBetween: 30,
        slidesPerView: 1,
        speed: 500,
        autoplay: {
            delay: 5000,
        },
        pagination: {
            clickable: true,
            el: `.swiper-custom-paginations .latestTestimonialsSwiper`,
        },
        breakpoints: {
            767: {
                slidesPerView: 2,
            }
        }
    }
    return (
        <section className={`${styles.root} ${className} py-5`}>
            <Container>
                <div className="wrapper rounded-4 tertiary-bg p-4">
                    <div className="text-center my-4">
                        {title && (
                            <h2
                                className={`text-${titleColour?.variant}`}
                                style={{ color: titleColour?.custom }}
                            >
                                {title}
                            </h2>
                        )}
                        {content && (
                            <div dangerouslySetInnerHTML={{ __html: content }} />
                        )}
                    </div>
                    <div className="mt-4">
                        <Swiper {...settings}>
                            {items?.map((item, index) => (
                                <SwiperSlide key={index}>
                                    <Card className="border-0 bg-transparent py-4 px-md-5 px-4">
                                        <span className="quote-icon">
                                            <Quote />
                                        </span>
                                        {item?.content &&
                                            <div className="post-description" dangerouslySetInnerHTML={{ __html: item?.content }} />
                                        }
                                        {item?.title &&
                                            <p className="m-0"><strong>{item?.title}</strong></p>
                                        }
                                        {item?.position &&
                                            <p className="post-position"><small>{item?.position}</small></p>
                                        }
                                    </Card>
                                </SwiperSlide>
                            ))}
                        </Swiper>
                        <div className="text-center swiper-custom-paginations mt-4">
                            <div className="latestTestimonialsSwiper" />
                        </div>
                    </div>
                </div>
            </Container>
        </section>
    )
}

export default LatestTestimonials;
